var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prAndFlexGrow"},[_c('EchartsLayout',{attrs:{"option":_vm.option}}),_c('div',{staticClass:"infomation"},[_c('span',[_vm._v("男性 | "+_vm._s(_vm.maleNum))]),_c('span',[_vm._v("女性 | "+_vm._s(_vm.femaleNum))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }